import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the datatable for the casino report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' },
                {
                    id: 'Username',
                    header: _('Usuario'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Game', header: _('Juego'), width: 100, sort: 'int' },
                {
                    id: 'ProviderName',
                    header: _('Proveedor'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Bets', header: _('Apuestas'), width: 100, sort: 'int' },
                {
                    id: 'Stakes',
                    header: _('Valor'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Winnings',
                    header: _('Premios'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Categorie',
                    header: _('Ganancias'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Profit',
                    header: _('Beneficios %'), // Localized header
                    width: 150,
                    sort: 'int',
                },
            ],
            on: {
                // Event handlers
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            ready: function () {
                // When the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized no data message
                            '</div>',
                    );
                }
            },
            footer: true, // Enable footer
            math: true, // Enable math functions
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport'; // API URL for fetching report
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data into grid
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                // Load data for selected player
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id,
            );
        });
    }
}

// FILE DOCUMENTED
